module.exports = __webpack_public_path__ + "static/creativedrive-b374674f9347a19cffc032fed8327227.jpg";